import { OverlayRef } from "@angular/cdk/overlay";
import { Component } from "@angular/core";
import { NgClass } from "@angular/common";

/**
 * PURPOSE: provides a reusable toast with configurable features.
 */
@Component({
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  standalone: true,
  imports: [NgClass],
  styleUrl: "./toast.component.scss"
})
export class ToastComponent {
  public data?: {
    message: string;
    action: string;
    panelClass?: string[];
    duration?: number;
  };

  private overlayRef?: OverlayRef;

  protected close(): void {
    this.overlayRef?.dispose();
  }

  public setOverlayRef(overlayRef: OverlayRef): void {
    this.overlayRef = overlayRef;
  }
}
